import { debounce } from "debounce";

window.addEventListener('resize', debounce(resize, 200));

function resize(e) {
    console.log('height', window.innerHeight);
    console.log('width', window.innerWidth);
}